<template>
  <div class="manage-layout-box">
    <left-menu></left-menu>
    <div class="manage-layout-sub-box">
      <router-view/>
    </div>
  </div>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu';
export default {
  name: 'ManageLayout',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    LeftMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.$store.commit('loginInfo/set_login_type', 'manage');
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.manage-layout-box {
  .manage-layout-sub-box {
    padding: 20px 20px 20px 10px;
    margin: 0 0 0 210px;
  }
  @media (max-width: 767px) {
    .manage-layout-sub-box {
      padding: 10px;
      margin: 0 0 0 0;
    }
  }
}
</style>
